import { AUTH_BASE_URL } from "../../props";
import { useDelete, useGet, usePost, usePut } from "../../common/fetchServices";

const sipServersUrl = () => `${AUTH_BASE_URL}/sip/servers`;
const getSipServerUrl = ({ sipServerId }) =>
  `${sipServersUrl()}/${sipServerId}`;

export const useSipServers = () => {
  const url = `${sipServersUrl()}?limit=9999&offset=0`;
  return useGet(["sip_servers"], url);
};

export const useCreateSipServer = () => {
  return usePost(sipServersUrl, {
    queriesToInvalidate: [["sip_servers"]],
  });
};

export const useUpdateSipServer = () => {
  return usePut(getSipServerUrl, {
    queriesToInvalidate: [["sip_servers"]],
  });
};

export const useDeleteSipServer = () => {
  return useDelete(getSipServerUrl, {
    queriesToInvalidate: [["sip_servers"]],
  });
};
